var _path, _path2, _path3, _path4, _path5, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSedanRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 185,
    viewBox: "0 0 558 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151 5.50004C153.4 3.50004 166.334 6.33337 172.5 8.00004C251 -2.99992 281 4.00008 326.5 11L433 60.5C465.8 58.9 512.333 75.5 531.5 84C534 84.5 550 96 550.5 99.5C550.9 102.3 551.667 124.333 552 135L555 144.5L548.5 149C551.3 149.8 554 153 555 154.5L552 160.5H543L541.5 162L489.5 164.5C489.5 73.5 382 95 395.5 169H392C390 167 388.167 166.833 387.5 167L150.5 158.5C138 76.5 54 96.5 64 160H57.5L50.5 153C45.3 152.6 18.0003 151 9.5 145.5C5.9 143.9 4.00053 134.833 3.50079 130.5C2.66745 131.167 1.50079 131.9 3.50079 129.5C6.00079 126.5 5.50079 114 5.50079 110C5.50079 106.8 6.50079 104 7.00079 103L15.5008 84V76.5C16.6673 71.5 18.8003 60.4 18.0003 56C17.0003 50.5 21.5003 48.5 22.5003 49C23.3003 49.4 40.5003 47.5 49.0003 46.5C76.5003 34.5 151 11.5 152.5 11C153.7 10.6 152 7.1667 151 5.50004Z",
    stroke: "#FFFF00",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.999 35.5006C132 19.5006 197 10.0006 224.5 12.5006C226 12.637 226.499 15.8339 226 17.5006V55.0006L137.5 50.0006C119 48.5006 109.333 45.0006 106 42.5006C102.4 39.3006 105.166 36.5006 106.999 35.5006Z",
    stroke: "#FFFF00",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5 57.0006L242 14.0006C296 6.00061 355 42.2506 372 55.0006C386.4 65.8006 372 67.0006 366 67.0006L249.5 57.0006Z",
    stroke: "#FFFF00",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5005 84.5006L17.5005 79.0006C17.1005 77.4006 19.3338 67.3339 20.5005 62.5006C24.5005 60.9006 56.5005 61.834 72.0005 62.5006C71.2005 68.5006 60.6671 70.6673 55.5005 71.0006C42.7005 68.6006 32.1671 79.0006 28.5005 84.5006Z",
    stroke: "#FFFF00",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M507 105.501C489.8 101.101 466.5 85.3339 457 78.0006C507 82.5006 520 89.0006 547.5 100.501L536.5 107.501C531.7 104.701 514.833 105.001 507 105.501Z",
    stroke: "#FFFF00",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 146,
    r: 34,
    stroke: "#FFFF00",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 441,
    cy: 150,
    r: 34,
    stroke: "#FFFF00",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedanRight);
export default __webpack_public_path__ + "static/media/sedan-right.8bb3964de31aa79cac8a3166e9e6bd01.svg";
export { ForwardRef as ReactComponent };